var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#fba682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#fda861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa936"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.839,
    x2: 286.45,
    xlinkHref: "#lg1",
    y1: 417.724,
    y2: 550.639
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#f12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#dd2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.321,
    x2: 298.081,
    xlinkHref: "#lg2",
    y1: 517.72,
    y2: 338.462
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.39,
    x2: 442.564,
    xlinkHref: "#lg2",
    y1: 450.436,
    y2: 386.27
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: 197.982,
    x2: 221.323,
    xlinkHref: "#lg2",
    y1: -601.089,
    y2: -568.73
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: 213.989,
    x2: 232.416,
    xlinkHref: "#lg2",
    y1: -621.524,
    y2: -595.978
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: 187.073,
    x2: 198.182,
    xlinkHref: "#lg2",
    y1: -622.239,
    y2: -606.838
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -245.378,
    x2: -228.131,
    xlinkHref: "#lg2",
    y1: -448.934,
    y2: -425.023
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -233.55,
    x2: -219.934,
    xlinkHref: "#lg2",
    y1: -464.034,
    y2: -445.158
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -253.439,
    x2: -245.231,
    xlinkHref: "#lg2",
    y1: -464.563,
    y2: -453.182
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 469.279,
    y2: 531.708
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a57c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#a26c4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 347.567,
    y2: 456.813
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42210b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210b"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.396,
    x2: 255.813,
    xlinkHref: "#lg4",
    y1: 397.577,
    y2: 307.948
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 480.969,
    x2: 419.477,
    xlinkHref: "#lg4",
    y1: 425.161,
    y2: 348.39
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.813,
    x2: 286.535,
    xlinkHref: "#lg4",
    y1: 453.384,
    y2: 389.6
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.173,
    x2: 326.779,
    xlinkHref: "#lg5",
    y1: 348.867,
    y2: 438.473
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#b0ce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95ae00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 318.54,
    y2: 411.314
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#798c00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464f00"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.708,
    x2: 261.727,
    xlinkHref: "#lg7",
    y1: 380.591,
    y2: 294.018
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.772,
    x2: 100.689,
    xlinkHref: "#lg7",
    y1: 384.375,
    y2: 227.015
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.741,
    x2: 417.512,
    xlinkHref: "#lg7",
    y1: 391.416,
    y2: 331.833
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdecf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#fdc4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#fbae97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.004,
    x2: 445.675,
    xlinkHref: "#lg8",
    y1: 338.712,
    y2: 387.205
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#fe5b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#fc4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg9",
    y1: 305.554,
    y2: 351.444
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.332,
    x2: 127.758,
    xlinkHref: "#lg10",
    y1: 370.095,
    y2: 264.679
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.032,
    x2: 378.68,
    xlinkHref: "#lg10",
    y1: 359.675,
    y2: 307.731
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 220.799,
    y2: 330.045
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.396,
    x2: 255.813,
    xlinkHref: "#lg4",
    y1: 270.809,
    y2: 181.18
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.803,
    x2: 336.387,
    xlinkHref: "#lg4",
    y1: 332.953,
    y2: 240.269
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.212,
    x2: 395.818,
    xlinkHref: "#lg5",
    y1: 222.099,
    y2: 311.705
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.648,
    x2: 109.241,
    xlinkHref: "#lg4",
    y1: 318.309,
    y2: 251.596
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.115,
    x2: 107.787,
    xlinkHref: "#lg8",
    y1: 247.81,
    y2: 296.302
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 191.771,
    y2: 284.546
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.708,
    x2: 261.727,
    xlinkHref: "#lg7",
    y1: 253.829,
    y2: 167.256
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg9",
    y1: 178.785,
    y2: 224.676
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.343,
    x2: 256.107,
    xlinkHref: "#lg10",
    y1: 227.045,
    y2: 150.657
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.385,
    x2: 276.049,
    xlinkHref: "#lg1",
    y1: 29.509,
    y2: 209.402
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: -137.33,
    x2: -113.989,
    xlinkHref: "#lg2",
    y1: -246.2,
    y2: -213.841
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: -121.323,
    x2: -102.896,
    xlinkHref: "#lg2",
    y1: -266.636,
    y2: -241.09
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-.999 -.055 .055 -.999 310.88 -132.595)",
    gradientUnits: "userSpaceOnUse",
    x1: -148.239,
    x2: -137.13,
    xlinkHref: "#lg2",
    y1: -267.351,
    y2: -251.949
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -204.445,
    x2: -187.198,
    xlinkHref: "#lg2",
    y1: 37.589,
    y2: 61.5
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -192.617,
    x2: -179.001,
    xlinkHref: "#lg2",
    y1: 22.488,
    y2: 41.365
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(-.625 -.781 .781 -.625 312.485 -10.69)",
    gradientUnits: "userSpaceOnUse",
    x1: -212.506,
    x2: -204.298,
    xlinkHref: "#lg2",
    y1: 21.96,
    y2: 33.34
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 119.19,
    y2: 209.935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2497,
    stopColor: "#f32816",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    stopColor: "#e5281d",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    stopColor: "#ce2727",
    stopOpacity: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.799,
    x2: 144.892,
    xlinkHref: "#lg8",
    y1: 107.612,
    y2: 122.38
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.7,
    x2: 220.792,
    xlinkHref: "#lg8",
    y1: 107.612,
    y2: 122.38
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.6,
    x2: 296.693,
    xlinkHref: "#lg8",
    y1: 107.612,
    y2: 122.38
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.501,
    x2: 372.593,
    xlinkHref: "#lg8",
    y1: 107.612,
    y2: 122.38
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.849,
    x2: 106.942,
    xlinkHref: "#lg8",
    y1: 72.473,
    y2: 87.242
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.75,
    x2: 182.842,
    xlinkHref: "#lg8",
    y1: 72.473,
    y2: 87.242
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.65,
    x2: 258.743,
    xlinkHref: "#lg8",
    y1: 72.473,
    y2: 87.242
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.55,
    x2: 334.643,
    xlinkHref: "#lg8",
    y1: 72.473,
    y2: 87.242
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.451,
    x2: 410.543,
    xlinkHref: "#lg8",
    y1: 72.473,
    y2: 87.242
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.799,
    x2: 144.892,
    xlinkHref: "#lg8",
    y1: 37.335,
    y2: 52.103
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.7,
    x2: 220.792,
    xlinkHref: "#lg8",
    y1: 37.335,
    y2: 52.103
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.6,
    x2: 296.693,
    xlinkHref: "#lg8",
    y1: 37.335,
    y2: 52.103
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.501,
    x2: 372.593,
    xlinkHref: "#lg8",
    y1: 37.335,
    y2: 52.103
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.65,
    x2: 258.743,
    xlinkHref: "#lg8",
    y1: 2.196,
    y2: 16.964
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientTransform: "matrix(.981 .196 -.196 .981 -112.422 139.145)",
    gradientUnits: "userSpaceOnUse",
    x1: 406.71,
    x2: 411.803,
    xlinkHref: "#lg8",
    y1: -216.964,
    y2: -202.196
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientTransform: "matrix(-.981 .196 .196 .981 -1406.217 139.145)",
    gradientUnits: "userSpaceOnUse",
    x1: -1582.589,
    x2: -1577.496,
    xlinkHref: "#lg8",
    y1: 180.611,
    y2: 195.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.446 422.882c0 33.949 23.803 63.214 57.027 70.192 49.846 10.469 118.159 16.926 193.527 16.926s143.681-6.457 193.527-16.926c33.224-6.978 57.027-36.242 57.027-70.191 0-11.591-11.23-19.921-22.29-16.456-49.747 15.583-133.404 25.815-228.264 25.815s-178.517-10.232-228.264-25.816c-11.06-3.465-22.29 4.866-22.29 16.456z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.666 431.181 78.552 78.552c64.924-1.308 123.312-7.42 167.308-16.66 12.551-2.636 23.753-8.456 32.84-16.504l-56.786-56.786c-46.807 7.804-105.639 12.458-169.581 12.458-17.894.001-35.388-.364-52.333-1.06z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.264 406.426c-20.399 6.39-46.507 11.878-76.743 16.132l62.694 62.694c21.978-12.469 36.34-36.004 36.34-62.37-.001-11.59-11.231-19.921-22.291-16.456z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 73.167,
    cy: 445.87,
    fill: "url(#SVGID_4_)",
    r: 8.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.516,
    cy: 467.668,
    fill: "url(#SVGID_5_)",
    r: 6.655
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.522,
    cy: 473.252,
    fill: "url(#SVGID_6_)",
    r: 4.012
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 117.737,
    cy: 452.223,
    fill: "url(#SVGID_7_)",
    r: 6.229
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.022,
    cy: 454.342,
    fill: "url(#SVGID_8_)",
    r: 4.917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.237,
    cy: 473.068,
    fill: "url(#SVGID_9_)",
    r: 2.965
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m10.175 450.946c8.968 21.052 27.763 37.185 51.298 42.128 49.846 10.469 118.159 16.926 193.527 16.926s143.681-6.457 193.527-16.926c23.535-4.943 42.33-21.075 51.298-42.128z",
    fill: "url(#SVGID_10_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m4.446 354.78v16.157c0 23.379 15.755 43.915 38.403 49.717 50.683 12.983 126.904 21.244 212.151 21.244s161.468-8.261 212.151-21.244c22.648-5.802 38.403-26.337 38.403-49.717v-16.157c0-11.591-11.23-19.921-22.29-16.456-49.747 15.584-133.404 25.816-228.264 25.816s-178.517-10.232-228.264-25.816c-11.06-3.465-22.29 4.866-22.29 16.456z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.264 338.324c-49.747 15.584-133.403 25.816-228.264 25.816-94.86 0-178.517-10.232-228.264-25.816-6.111-1.914-12.263-.217-16.555 3.63l89.756 89.756c44.212 6.428 97.578 10.188 155.062 10.188 85.247 0 161.468-8.261 212.151-21.244 22.648-5.802 38.403-26.337 38.403-49.717v-16.157c.001-11.59-11.229-19.921-22.289-16.456z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.554 370.937v-11.354l-21.464-21.463c-.276.072-.551.118-.826.205-26.573 8.324-62.826 15.119-105.289 19.646v27.778c0 6.228 2.818 11.794 7.243 15.507l29.728 29.728c19.406-2.954 36.967-6.426 52.205-10.33 22.648-5.802 38.403-26.337 38.403-49.717z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.141 359.344c-33.477 3.085-70.371 4.796-109.141 4.796-38.59 0-75.324-1.694-108.677-4.752-3.067 5.539-2.583 12.867 2.489 17.939l63.876 63.876c13.797.454 27.921.695 42.312.695 67.739 0 129.762-5.22 177.818-13.877z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.924 352.337c-65.154-19.741-134.694-19.741-199.848 0-10.857 3.29-14.286 16.968-6.264 24.99l77.485 77.485c15.852 15.852 41.554 15.852 57.406 0l77.485-77.485c8.022-8.022 4.593-21.7-6.264-24.99z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.554 328.215c0-70.876-501.108-70.876-501.108 0 0 12.22 14.905 22.332 39.564 30.338 8.958 2.908 17.22 7.629 24.128 14.03l.741.686c15.02 13.919 36.766 17.825 55.69 10.003l.014-.006c16.166-6.682 34.598-4.885 49.169 4.794l1.386.921c16.067 10.672 36.729 11.548 53.641 2.274l1.292-.709c15.533-8.518 34.339-8.52 49.873-.004l1.302.713c16.914 9.272 37.577 8.393 53.643-2.281l1.681-1.117c14.489-9.626 32.838-11.349 48.866-4.59 18.786 7.922 40.47 4.107 55.423-9.753l1.006-.932c6.907-6.402 15.169-11.122 24.126-14.03 24.659-8.005 39.563-18.117 39.563-30.337z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.554 328.213c0 12.222-14.911 22.321-39.569 30.326-8.953 2.918-17.218 7.639-24.123 14.04l-1.008.932c-9.762 9.06-22.428 13.826-35.261 13.826-6.799 0-13.658-1.329-20.151-4.079-16.026-6.753-34.375-5.026-48.873 4.599l-1.681 1.115c-16.057 10.664-36.728 11.55-53.64 2.276l-1.299-.718c-15.537-8.51-34.344-8.51-49.882.015l-1.283.703c-16.912 9.273-37.583 8.403-53.64-2.276l-1.39-.917c-14.575-9.686-33-11.474-49.164-4.797h-.015c-11.076 4.568-23.1 5.149-34.191 2.032l-64.487-64.487c-3.437-3.163-6.34-6.875-8.586-10.969 28.844-19.082 102.605-30.311 184.31-33.687 35.093-1.451 71.668-1.451 106.76 0 105.171 4.339 197.173 21.694 197.173 52.066z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.44 277.456c-54.952 3.455-104.298 10.645-135.89 21.576 1.03 4.863 3.789 9.085 7.627 11.975l73.383 73.383c1.009-.346 2.015-.707 3.009-1.118l.014-.006c16.166-6.682 34.598-4.885 49.169 4.794l1.386.921c16.067 10.672 36.729 11.548 53.641 2.274l1.292-.709c15.533-8.518 34.339-8.519 49.873-.004l1.302.714c4.531 2.483 9.333 4.215 14.241 5.248z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.537 317.567h-85.562v63.226c2.525.638 5.022 1.446 7.461 2.474 18.786 7.922 40.47 4.107 55.423-9.753l1.006-.932c6.907-6.402 15.169-11.122 24.126-14.03 10.949-3.555 19.968-7.525 26.62-11.911z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.975 317.567v68.181c0 11.179 9.062 20.241 20.241 20.241 11.179 0 20.241-9.062 20.241-20.241v-13.813c0-3.873 3.139-7.012 7.012-7.012 3.873 0 7.012 3.139 7.012 7.012v1.124c0 8.576 6.952 15.528 15.528 15.528 8.576 0 15.528-6.952 15.528-15.528v-55.492z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.871 287.694v1.122c0 19.547 13.02 36.748 31.875 41.903 49.075 13.417 125.453 22.041 211.254 22.041s162.179-8.624 211.254-22.041c18.855-5.155 31.875-22.355 31.875-41.903 0-.372 0-.744 0-1.118 0-20.507-19.272-35.526-39.163-30.538-49.165 12.328-122.285 20.146-203.966 20.146s-154.801-7.818-203.966-20.145c-19.892-4.988-39.163 10.026-39.163 30.533z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.594 274.61c-48.2-3.285-90.481-9.406-122.561-17.45-3.711-.931-7.4-1.163-10.947-.796v38.481c0 6.613 3.185 12.467 8.09 16.161l26.914 26.914c46.821 9.074 108.686 14.654 176.643 14.828z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458 257.396c-49.154 12.19-121.846 19.91-203 19.91-3.502 0-6.981-.02-10.45-.048l73.884 73.884c59.502-3.089 111.246-10.423 147.82-20.422 16.243-4.441 28.133-17.829 31.121-33.948z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.446 228.012v16.157c0 23.379 15.755 43.915 38.403 49.717 50.683 12.983 126.904 21.244 212.151 21.244s161.468-8.261 212.151-21.244c22.648-5.802 38.403-26.337 38.403-49.717v-16.157c0-11.591-11.23-19.921-22.29-16.456-49.747 15.584-133.404 25.816-228.264 25.816s-178.517-10.232-228.264-25.816c-11.06-3.465-22.29 4.866-22.29 16.456z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.264 211.556c-49.747 15.584-133.403 25.816-228.264 25.816-94.86 0-178.517-10.232-228.264-25.816-6.111-1.914-12.263-.217-16.555 3.63l89.756 89.756c44.213 6.428 97.579 10.188 155.063 10.188 85.247 0 161.468-8.261 212.151-21.244 22.648-5.802 38.403-26.337 38.403-49.717v-16.157c0-11.59-11.23-19.921-22.29-16.456z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.527 284.923-60.142-60.142c-46.935 7.884-106.077 12.591-170.385 12.591-13.997 0-27.741-.228-41.177-.658-1.048 4.725.132 9.949 4.028 13.845l63.876 63.876c2.626.087 5.275.158 7.925.228 71.095-1.904 133.795-9.582 177.498-20.778 6.838-1.751 13.04-4.852 18.377-8.962z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.963 225.569c-65.153-19.741-134.694-19.741-199.848 0-10.857 3.29-14.286 16.968-6.264 24.99l77.485 77.485c15.852 15.852 41.554 15.852 57.406 0l77.485-77.485c8.022-8.022 4.593-21.7-6.264-24.99z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.849 293.886c42.284 10.832 102.35 18.372 170.596 20.575l-83.483-83.483c-11.676-1.271-22.877-2.713-33.522-4.313h-56.353v66.419c.91.289 1.828.563 2.762.802z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.087 226.665v68.181c0 11.179 9.062 20.241 20.241 20.241 11.179 0 20.241-9.062 20.241-20.241v-13.813c0-3.873 3.139-7.012 7.012-7.012 3.873 0 7.012 3.139 7.012 7.012v1.124c0 8.576 6.952 15.528 15.528 15.528 8.576 0 15.528-6.952 15.528-15.528v-55.492z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.554 201.447c0-70.876-501.108-70.876-501.108 0 0 12.22 14.905 22.332 39.564 30.338 8.958 2.908 17.22 7.629 24.128 14.03l.741.686c15.02 13.919 36.766 17.825 55.69 10.003l.014-.006c16.166-6.682 34.598-4.885 49.169 4.794l1.386.921c16.067 10.672 36.729 11.548 53.641 2.274l1.292-.709c15.533-8.518 34.339-8.52 49.873-.004l1.302.713c16.914 9.272 37.577 8.393 53.643-2.281l1.681-1.117c14.489-9.626 32.838-11.349 48.866-4.59 18.786 7.923 40.47 4.107 55.423-9.753l1.006-.932c6.907-6.402 15.169-11.122 24.126-14.03 24.659-8.005 39.563-18.117 39.563-30.337z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.554 201.451c0 12.222-14.911 22.321-39.569 30.326-8.953 2.918-17.218 7.639-24.123 14.04l-1.008.932c-9.762 9.06-22.428 13.826-35.261 13.826-6.799 0-13.658-1.329-20.151-4.079-16.026-6.753-34.375-5.026-48.873 4.599l-1.681 1.115c-16.057 10.664-36.728 11.55-53.64 2.276l-1.299-.718c-15.537-8.51-34.344-8.51-49.882.015l-1.283.703c-16.912 9.273-37.583 8.403-53.64-2.276l-1.39-.917c-14.575-9.686-33-11.474-49.164-4.797h-.015c-11.076 4.568-23.1 5.149-34.191 2.032l-64.487-64.487c-3.437-3.163-6.34-6.875-8.586-10.969 28.844-19.082 102.605-30.311 184.31-33.687 35.093-1.451 71.668-1.451 106.76 0 105.171 4.339 197.173 21.694 197.173 52.066z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.871 160.926v1.122c0 19.547 13.02 36.748 31.875 41.903 49.075 13.417 125.453 22.041 211.254 22.041s162.179-8.624 211.254-22.041c18.855-5.155 31.875-22.355 31.875-41.903 0-.372 0-.744 0-1.118 0-20.507-19.272-35.525-39.163-30.538-49.165 12.328-122.285 20.146-203.966 20.146s-154.801-7.818-203.966-20.145c-19.892-4.988-39.163 10.026-39.163 30.533z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.129 160.935v1.115c0 19.54-13.017 36.743-31.869 41.907-49.087 13.414-125.46 22.03-211.26 22.03-68.918 0-131.755-5.561-179.253-14.697l-61.768-61.768c5.531-14.254 21.083-23.13 37.048-19.128 49.164 12.329 122.298 20.136 203.972 20.136s154.809-7.807 203.972-20.136c19.893-4.995 39.158 10.023 39.158 30.541z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 133.318c0 70.876-510 70.876-510 0s114.167-128.332 255-128.332 255 57.456 255 128.332z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 427.518,
    cy: 109.99,
    fill: "url(#SVGID_35_)",
    r: 8.429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.867,
    cy: 131.788,
    fill: "url(#SVGID_36_)",
    r: 6.655
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.873,
    cy: 137.372,
    fill: "url(#SVGID_37_)",
    r: 4.012
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 472.088,
    cy: 116.343,
    fill: "url(#SVGID_38_)",
    r: 6.229
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.373,
    cy: 118.463,
    fill: "url(#SVGID_39_)",
    r: 4.917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 463.588,
    cy: 137.188,
    fill: "url(#SVGID_40_)",
    r: 2.965
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m0 133.319c0 70.876 510 70.876 510 0 0-13.079-3.899-25.699-11.125-37.588h-487.75c-7.226 11.888-11.125 24.508-11.125 37.588z",
    fill: "url(#SVGID_41_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.149,
    cy: 111.527,
    fill: "url(#SVGID_42_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.05,
    cy: 111.527,
    fill: "url(#SVGID_43_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.95,
    cy: 111.527,
    fill: "url(#SVGID_44_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.851,
    cy: 111.527,
    fill: "url(#SVGID_45_)",
    rx: 13.955,
    ry: 6.111
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.199,
    cy: 76.388,
    fill: "url(#SVGID_46_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.1,
    cy: 76.388,
    fill: "url(#SVGID_47_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 76.388,
    fill: "url(#SVGID_48_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 330.9,
    cy: 76.388,
    fill: "url(#SVGID_49_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.801,
    cy: 76.388,
    fill: "url(#SVGID_50_)",
    rx: 13.955,
    ry: 6.111
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.149,
    cy: 41.25,
    fill: "url(#SVGID_51_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.05,
    cy: 41.25,
    fill: "url(#SVGID_52_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.95,
    cy: 41.25,
    fill: "url(#SVGID_53_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.851,
    cy: 41.25,
    fill: "url(#SVGID_54_)",
    rx: 13.955,
    ry: 6.111
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 6.111,
    fill: "url(#SVGID_55_)",
    rx: 13.955,
    ry: 6.111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.163 12.935c-.661 3.31-7.325 4.768-14.882 3.258-7.558-1.51-13.149-5.418-12.487-8.728.661-3.31 7.325-4.768 14.882-3.258s13.149 5.418 12.487 8.728z",
    fill: "url(#SVGID_56_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.837 12.935c.661 3.31 7.325 4.768 14.882 3.258 7.558-1.51 13.149-5.418 12.487-8.728s-7.325-4.768-14.882-3.258c-7.558 1.511-13.149 5.418-12.487 8.728z",
    fill: "url(#SVGID_57_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBurger);
export default __webpack_public_path__ + "static/media/icon-burger.126e64149da8af6981d7d3e30db2f1a7.svg";
export { ForwardRef as ReactComponent };